import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=4a60636b&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a60636b')) {
      api.createRecord('4a60636b', component.options)
    } else {
      api.reload('4a60636b', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=4a60636b&", function () {
      api.rerender('4a60636b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8nBPJ0poyi4xR/JS/imageCarousel.vue"
export default component.exports